import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import FinanceView from './finance.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useFinanceRoutes = () => {
  const financeComponent = (
    <ProtectedRoute module="finance" checkAnySubmodule>
      <FinanceView />
    </ProtectedRoute>
  );
  return (
    <Route path={pages.finance.path} element={financeComponent}>
      <Route
        path={`${pages.finance.path}/:financeSubRouteId`}
        element={financeComponent}
      />
    </Route>
  );
};

export default useFinanceRoutes;
